import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import 'react-dates/initialize'
import ModalFullScreen from '../../mini/ModalFullScreen'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import CloseModal from '../../styled/CloseModal'
import { hideModal } from '../../../actions/_modal'
import { submitCloseJourneySection } from './API'

import {
  SaveButton,
  CancelButton,
  HeaderBlock,
  Message,
  ButtonBlock,
  ModalQuestBlock,
  Container,
  Header,
  ModalTop,
  CourseSectionName,
  GradeLevelContainer
} from './_Styled'
import useLexicon from '../../../hooks/useLexicon'

const CloseJourneySections = ({
  orgId,
  token,
  courseSection,
  grade,
  id,
  onCourseSectionUpdate,
  isFetchingCloseSection
}) => {
  const [isClosing, setIsClosing] = useState(false)
  const dispatch = useDispatch()

  const color = courseSection.master_course.color

  const closeTheModal = () => {

    setIsClosing(true)

    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  const closeJourney = () => {
    dispatch(hideModal())
    submitCloseJourneySection({
      token,
      orgId,
      id,
      dispatch,
      onCourseSectionUpdate,
      isFetchingCloseSection
    })
  }

  const lexicon = useLexicon()

  return (
    <ModalFullScreen
      padding={'200px 0 0'}
      allowEscape
      closeCallback={() => closeTheModal()}
      isClosing={isClosing}
      backgroundColor='rgba(36, 54, 70, 0.4)'
      allowCloseOnExternalClick
      bodyStyles={{width: 'fit-content'}}
    >
      <CloseModal
        size={21}
        onClick={() => closeTheModal()}
        offWhiteIcon
      />
      <Container
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <React.Fragment>
          <ModalTop style={{border: 'none'}}>
            <CourseSectionName>
              <GradeLevelContainer>
                {grade}
              </GradeLevelContainer>
              <span style={{color: '#' + color}}>
                {courseSection.master_course.abbreviation}:&ensp;
              </span>
              <span style={{color: '#' + color}}>{courseSection.course.name} </span>
              <span>&ensp;|&ensp;
                {courseSection.name_clean}
              </span>
            </CourseSectionName>
            <FlexAlignCenter
              style={{
                position: 'relative',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <HeaderBlock>
                <Header>Are you sure you want to close this {lexicon.section.toLowerCase()}?</Header>
              </HeaderBlock>
            </FlexAlignCenter>
          </ModalTop>
          <ModalQuestBlock>
            <Message>
              <p style={{ margin: '0' }}>
                Once closed, students will no longer be able to begin new {lexicon.quest.toLowerCase()}s within this {lexicon.journey.toLowerCase()} {lexicon.section.toLowerCase()}.
              </p>
            </Message>
          </ModalQuestBlock>
          <ButtonBlock>
            <CancelButton onClick={() => closeTheModal()}>Cancel</CancelButton>
            <SaveButton onClick={() => closeJourney()}>Close {lexicon.section}</SaveButton>
          </ButtonBlock>
        </React.Fragment>
      </Container>
    </ModalFullScreen>
  )
}

CloseJourneySections.propTypes = {
  orgId: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  courseSection: PropTypes.object.isRequired,
  grade: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  onCourseSectionUpdate: PropTypes.func.isRequired,
  isFetchingCloseSection: PropTypes.func.isRequired,
}

export default CloseJourneySections
